function MediaPreviewModalContent({ url, onClose }: { url: string; onClose: () => void }) {
  return (
    <div className="flex flex-col flex-1 w-full h-[95vh]">
      <img src={url} alt="" className="object-scale-down h-full w-full" />
    </div>
  );
}

export default MediaPreviewModalContent;
